import React, { memo } from 'react';
import { areEqual } from 'react-window';

import styles from './styles.scss';

const FieldItem = ({ data, index, style, children: Children }) => (
  <div className={ styles.listItem } style={ style }>
    <Children data={ data } rowIndex={ index } />
  </div>
);

export default memo(FieldItem, areEqual);
